import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TreatyStats } from '../models/treaty-with-stats.model';
import { TreatyTableComponent } from '../treaty-table/treaty-table.component';

@Component({
  selector: 'app-treaty-stats-detail',
  imports: [TreatyTableComponent],
  template: `
    @if (treatyStats()) {
      <div>
        <h2>SUMMARY</h2>
        <h3>Based on the assessment, this bordereau potentially has:</h3>
        <ul>
          @for (item of treatyStats().summaryStats; track item) {
            <li>{{ item }}</li>
          }
        </ul>
      </div>

      <div class="treaty-mt-2">
        <h2>ANALYSIS</h2>
        <h3>Controversy stats</h3>
        <app-treaty-table [colDefs]="controversyCols" [rowData]="treatyStats().controversyStats" domLayout="autoHeight"></app-treaty-table>
      </div>

      <div class="treaty-mt-2">
        <h3>Company risk score stats</h3>
        <app-treaty-table
          [colDefs]="companyRiskScoreCols"
          [rowData]="treatyStats().companyScoreStats"
          domLayout="autoHeight"
        ></app-treaty-table>
      </div>

      <div class="treaty-mt-2">
        <h3>Country Sector risk score stats</h3>
        <app-treaty-table
          [colDefs]="countrySectorRiskScoreCols"
          [rowData]="treatyStats().countrySectorScoreStats"
          domLayout="autoHeight"
        ></app-treaty-table>
        <p class="explanation-text">{{ treatyStats().countrySectorStatsExplanation }}</p>
      </div>

      <div class="treaty-mt-2">
        <h3>Fossil fuel occupancies</h3>
        <app-treaty-table [colDefs]="sectorFossilFuelCols" [rowData]="treatyStats().sectorFossilFuelStats" domLayout="autoHeight">
        </app-treaty-table>
      </div>

      <div class="treaty-mt-2">
        <h3>Country Sector High Risk & Abstain stats</h3>
        <app-treaty-table
          [colDefs]="countrySectorValueCols"
          [rowData]="treatyStats().countrySectorValueStats"
          domLayout="autoHeight"
        ></app-treaty-table>
      </div>

      <h3 class="treaty-mt-2">Should the UW take action?</h3>
      <ul>
        @for (item of treatyStats().recommendationStats; track item) {
          <li>{{ item }}</li>
        }
      </ul>
    }
  `,
  styles: `
    :host {
      display: block;
    }

    .treaty-mt-2 {
      margin-top: 2rem;
    }

    .explanation-text {
      padding: 0.5rem;
      font-size: 14px;
    }

    ul {
      padding-left: 1rem;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TreatyStatsDetailComponent {
  treatyStats = input.required<TreatyStats>();

  controversyCols = [
    { field: 'name', headerName: 'Controversies' },
    { field: 'value', headerName: 'Sum of value % share' },
  ];

  companyRiskScoreCols = [
    { field: 'name', headerName: 'Company risk score' },
    { field: 'value', headerName: 'Sum of value % share' },
  ];

  countrySectorRiskScoreCols = [
    { field: 'name', headerName: 'Country/Sector risk score' },
    { field: 'value', headerName: 'Sum of value % share' },
  ];

  countrySectorValueCols = [
    { field: 'country', headerName: 'Country' },
    { field: 'sector', headerName: 'Sector' },
    {
      field: 'value',
      headerName: 'Sum of value % share (only of Abstain/High Risk)',
    },
  ];

  sectorFossilFuelCols = [
    { field: 'name', headerName: 'Fossil fuel occupancies' },
    { field: 'value', headerName: 'Sum of value % share' },
  ];
}
